import { Navigate, useParams, useLocation } from "react-router";

export const Redirect = () => {
    const { id } = useParams();
    const { pathname } = useLocation();
    return <Navigate to={`/${pathname.split('/')[1]}/exhibitor/${id}`}/>
};

export default Redirect;
